import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { createSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {
  countryCodeData,
  countryCodeDataInterface,
} from '../../profile/edit-phone-number/country-codes';
import parsePhoneNumber from 'libphonenumber-js';
import { getPreferredCountries } from '../../store/remote-config/remote-config.selectors';

interface PhoneInputInterface {
  countryCode?: string;
  mobileNumber?: string;
  valid?: boolean;
}

@Component({
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CaPhoneNumberInputComponent),
    },
  ],
  selector: 'ca-phone-number-input',
  styleUrls: ['./phone-number-input.component.scss'],
  templateUrl: './phone-number-input.component.html',
})
export class CaPhoneNumberInputComponent implements OnInit, ControlValueAccessor {
  mobileNumber: string;
  selectedCountry: countryCodeDataInterface;
  isValid: boolean = false;

  disabled: boolean;
  preferredCountries$: Observable<string[]>;
  countryCodeData = countryCodeData;
  countryCodeList = Object.keys(countryCodeData);

  private onChange: Function;
  private onTouched: Function;

  constructor(public store: Store<any>) {}

  ngOnInit() {
    this.preferredCountries$ = this.store.select(getPreferredCountries);
  }

  update(value?: PhoneInputInterface) {
    if (value != null) {
      if (value.countryCode != null) {
        this.selectedCountry = countryCodeData[value.countryCode];
      }
      if (value.mobileNumber != null) {
        this.mobileNumber = value.mobileNumber;
      }
    }

    this.validatePhoneNumber();

    const data: PhoneInputInterface = {
      countryCode: this.selectedCountry?.key,
      mobileNumber: this.mobileNumber,
      valid: this.isValid,
    };

    if (this.onChange) {
      this.onChange(data);
    }

    if (this.onTouched) {
      this.onTouched();
    }
  }

  validatePhoneNumber(): void {
    if (this.mobileNumber != null && this.selectedCountry != null) {
      const parsed = parsePhoneNumber(this.mobileNumber, this.selectedCountry.key);
      if (parsed && parsed.isValid()) {
        this.mobileNumber = parsed.number as string;
        this.isValid = true;
      } else {
        this.isValid = false;
      }
    }
  }

  writeValue(value: PhoneInputInterface): void {
    if (!!value && (value.mobileNumber ?? false)) {
      this.mobileNumber = value.mobileNumber;
    } else {
      this.mobileNumber = '';
    }

    if (!!value && (value.countryCode ?? false)) {
      this.selectedCountry = countryCodeData[value.countryCode];
    } else {
      this.selectedCountry = countryCodeData.AU;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
